import { useCallback, useEffect } from 'react';

import { useGlobalContext } from 'context/GlobalContext';
import { AccessElements } from 'helpers/app.config';
import useGetTicketComentsById from 'hooks/tickets/useGetTicketComentById';
import useGetTicketDetailById from 'hooks/tickets/useGetTicketDetailById';
import useCloseTicketServices from 'components/actions/ChangeStatus/hooks/useCloseTicketServices';
import useGetLocationDetail from 'pages/Ticket/ODT/Detail/hooks/useGetLocationDetail';

import useGetImagesByTicket from '../FileStorage/useGetImagesByTicket';
import useGetClientsDetail from '../Client/useGetClientDetail';
import useGetProyectDetail from './useServiceDetail';
import useGetMeSupplies from '../Supplies_and_Accesories/useGetMeSupplies';
import useGetTicketComments from '../Ticket/useGetComments';

const useTicketsExportApis = (ticketId: any) => {
  const { hasPerm } = useGlobalContext();
  const { ticket, isTicketDetailLoading } = useGetTicketDetailById({
    ticketId: ticketId?.ticketId
  });
  const toDataURL = (url: RequestInfo | URL) =>
    fetch(url)
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );

  const { getTicketComponentsByTicketId } = useCloseTicketServices({
    ticketId: ticket?.ticketId.toString()
  });

  useEffect(() => {
    if (ticket)
      ticket.ticketProduct =
        getTicketComponentsByTicketId?.data?.products || [];
  }, [getTicketComponentsByTicketId]);

  const { clientsDetail } = useGetClientsDetail({
    ticketClientId: ticket?.ticketClientId
  });

  const { clientProjectDetail } = useGetProyectDetail({
    ticketServiceId: ticket?.ticketServiceId
  });

  const { location, locationIsLoading } = useGetLocationDetail({
    clientId: ticket?.ticketClientId,
    locationName: ticket?.ticketLocationName
  });

  const { images } = useGetImagesByTicket({
    ticketId: ticket?.ticketId,
    fetch: hasPerm([AccessElements.TicketQueryFile])
  });

  const { supplies } = useGetMeSupplies({
    ticketId: ticket?.ticketId,
    btnOnClick: hasPerm([AccessElements.SuppliesSearch])
  });

  const { closeTicketComents } = useGetTicketComments({
    ticketId: ticket?.ticketId,
    ticketStatusId: ticket?.ticketStatusId,
    fetch: true
  });

  const getBase = useCallback(async () => {
    const prueba = await toDataURL(clientsDetail?.data?.blobStorageUrlPath);
    return prueba;
  }, [clientsDetail?.data?.blobStorageUrlPath]);

  const { GetComments, GetCommentsLoading } = useGetTicketComentsById({
    filterParams: {
      ticketId: ticket?.ticketId,
      orderColumn: 'CreatedDateTime',
      descending: true,
      NoInternal: true
    },
    queryProps: {
      pageNumber: 1,
      pageSize: 10000
    }
  });

  return {
    clientsDetail,
    clientProjectDetail,
    location,
    images,
    supplies,
    closeTicketComents,
    getBase,
    GetComments,
    ticket,
    isTicketDetailLoading,
    locationIsLoading,
    GetCommentsLoading
  };
};

export default useTicketsExportApis;
